export default "__VITE_ASSET__8e565e8c__"